module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_simple_rec_1.298f8f08.png";